import {
  APP_INITIALIZER,
  type EnvironmentProviders,
  makeEnvironmentProviders,
} from '@angular/core';
import { ColorSchemeService } from './color-scheme.service';

/** System-aware color scheme with optional user override (light / dark). */
export function provideSystemColorScheme(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: (colorScheme: ColorSchemeService) => () => colorScheme.init(),
      deps: [ColorSchemeService],
    },
  ]);
}
